import React from "react";
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group";

export interface QuickPeriod {
  label: string;
  days: number;
}

interface AnalyticsDateFilterProps {
  onQuickPeriodSelect: (period: QuickPeriod) => void;
  selectedPeriod?: QuickPeriod | null;
}

const QUICK_PERIODS: QuickPeriod[] = [
  { label: "1D", days: 1 },
  { label: "1W", days: 7 },
  { label: "1M", days: 30 },
];

const AnalyticsDateFilter: React.FC<AnalyticsDateFilterProps> = ({
  onQuickPeriodSelect,
  selectedPeriod,
}) => {
  const handleValueChange = (value: string) => {
    if (value) {
      const period = QUICK_PERIODS.find(p => p.label === value);
      if (period) {
        onQuickPeriodSelect(period);
      }
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={selectedPeriod?.label || ""}
      onValueChange={handleValueChange}
      className="gap-0"
    >
      {QUICK_PERIODS.map((period) => (
        <ToggleGroupItem
          key={period.label}
          value={period.label}
          size="sm"
          className="h-8 px-3 text-xs data-[state=on]:bg-maitai-green data-[state=on]:text-maitai"
        >
          {period.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};

export default AnalyticsDateFilter;
export { QUICK_PERIODS };